/**
 * Feature Flags — Learn With Trust
 * ────────────────────────────────────────────────────────────────
 * Centralised toggles for product features that are still in flux.
 * The goal is reversibility: a feature can be re-enabled by flipping
 * a single boolean here without rewiring components.
 *
 * Conventions:
 *   • Default to the production-safe value.
 *   • Pair every UI flag with a one-sentence rationale + planned re-enable date.
 *   • If a flag gates an API call too, also gate the call (not just the render)
 *     so we don't trigger 404s when the backend is also being trimmed.
 */

/**
 * RATINGS_ENABLED — when false, all student-facing rating UI is hidden:
 *   • star displays on teacher cards (Search, Directory, FeaturedTeachers, Profile)
 *   • "Rate this lesson" prompts and submission flows
 *   • Min-rating filters on search / tutor directory
 *
 * Why disabled (Feb 16, 2026): Founder feedback — early-stage marketplace,
 * pulling stars to lower the barrier for new teacher signups and avoid
 * "0.0" badges on profiles that have no reviews yet. The backend models
 * and admin tooling remain intact (AdminReviews still works) so we can
 * flip this back to true the moment we have organic review volume.
 */
export const RATINGS_ENABLED = false;
